import { render } from "./ContestantProfile.vue?vue&type=template&id=15acb465&scoped=true"
import script from "./ContestantProfile.vue?vue&type=script&lang=js"
export * from "./ContestantProfile.vue?vue&type=script&lang=js"

import "./ContestantProfile.vue?vue&type=style&index=0&id=15acb465&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15acb465"]])

export default __exports__